import React from "react";

export const GlassCard = ({ children, style = {}, isDark, className = "" }) => (
  <div className={`glass-before ${className}`} style={{
    background: isDark ? "rgba(15,23,42,0.5)" : "rgba(255,255,255,0.6)",
    backdropFilter: "blur(20px)",
    border: `1px solid ${isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.08)"}`,
    position: "relative",
    ...style,
  }}>
    {children}
  </div>
);